export default __webpack_public_path__ + "static/media/play-circle.164c9cab.svg";